import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#d13138',
    },
    secondary: {
      main: '#231f20',
    },
    info: {
      main: '#027eaa',
    },
    success: {
      main: '#05862d',
    },
  },
});

export default theme;
